import type { Key } from "react";
import type { LocationItem } from "./types";

import { getMarkerIcon } from "~www/lib/google-maps/map-pin";

/** Filters out locations with missing coords or (0, 0) which indicates ungeocoded data. */
function hasCoordinates(loc: LocationItem): loc is LocationItem & {
  coordinates: { latitude: number; longitude: number };
} {
  const c = loc.coordinates;
  return c != null && !(c.latitude === 0 && c.longitude === 0);
}

/** Replaces all markers on the map to match the current locations list. */
export function syncMarkersToMap(
  map: google.maps.Map,
  markers: Map<Key, google.maps.Marker>,
  locations: LocationItem[],
  selectedLocationId: Key | null,
  onSelectLocation: (id: Key) => void,
) {
  for (const marker of markers.values()) {
    marker.setMap(null);
  }
  markers.clear();

  for (const location of locations) {
    if (!hasCoordinates(location)) {
      continue;
    }

    const marker = new google.maps.Marker({
      icon: getMarkerIcon(location.id === selectedLocationId),
      map,
      position: {
        lat: location.coordinates.latitude,
        lng: location.coordinates.longitude,
      },
    });

    const locationId = location.id;
    marker.addListener("click", () => {
      onSelectLocation(locationId);
    });

    markers.set(locationId, marker);
  }
}
